/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-function-type */

export class TypeOf {
  static isString(value: any): value is string {
    return typeof value === "string";
  }

  static isNumber(value: any): value is number {
    return typeof value === "number";
  }

  static isBoolean(value: any): value is boolean {
    return typeof value === "boolean";
  }

  static isSymbol(value: any): value is symbol {
    return typeof value === "symbol";
  }

  static isObject(value: any): value is object | null {
    return typeof value === "object";
  }

  static isUndefined(value: any): value is undefined {
    return typeof value === "undefined";
  }

  static isFunction(value: any): value is Function {
    return typeof value === "function";
  }

  static isBigInt(value: any): value is bigint {
    return typeof value === "bigint";
  }
}
